var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ServicePageLayout',{attrs:{"title":"Smart Level","subtitle":"ระบบติดตามระดับน้ำ","icon":"mdi-waves-arrow-up","icon-color":"info","breadcrumb":"Operations"}})
}
var staticRenderFns = []

export { render, staticRenderFns }